import React from 'react'
import NumberFormat from 'react-number-format';
import { Link } from "react-router-dom";
import { useForm } from 'react-hook-form';
import { useTranslation } from '../hooks/useTranslation';

function OpenValueProduct({ idx, prod, lang, chainId, submitForm, getProductTranslations }) {
    const { t } = useTranslation();
    const { register, handleSubmit, formState: { errors } } = useForm({
        mode: 'onSubmit',
        reValidateMode: 'onChange',
        shouldFocusError: true,
    });
    
    return (
        <div>
            {/* voucher with fixed price */}
            {prod.productMinimumPrice && prod.productMaximumPrice && prod.productMinimumPrice === prod.productMaximumPrice ?
                <>
                    {!!idx == 0 ?
                        <h2 className="name" tabIndex="0" aria-label={getProductTranslations(prod).productName ? getProductTranslations(prod).productName : prod.productName} dangerouslySetInnerHTML={{ __html: getProductTranslations(prod).productName ? getProductTranslations(prod).productName : prod.productName }}></h2>
                        :
                        <h2 className="name" aria-label={getProductTranslations(prod).productName ? getProductTranslations(prod).productName : prod.productName} dangerouslySetInnerHTML={{ __html: getProductTranslations(prod).productName ? getProductTranslations(prod).productName : prod.productName }}></h2>
                    }
                    <div className="descr" role="application" aria-roledescription={t("Description")} aria-label={getProductTranslations(prod).productShortDescription} dangerouslySetInnerHTML={{ __html: getProductTranslations(prod).productShortDescription }}></div>
                    <div className="prod-box-bottom d-flex justify-content-between">
                    <div className="price" role="application" aria-roledescription={t("Price")} aria-label={prod.productMaximumPrice}>
                        <NumberFormat
                            value={prod.productMaximumPrice}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={
                            prod.currencyCode
                                .replace("ILS", "₪")
                                .replace("USD", "$")
                            }
                        />
                    </div>                        <Link
                            onClick={e => { e.preventDefault(); submitForm(prod, prod.productId, prod); }}
                            className="btn"
                            aria-label={`${t("MoreInfAndRsv")} ${getProductTranslations(prod).productName}`}
                            to={`/product?chainid=${chainId}&pid=${prod.productId}&lang=${lang}`}
                        >
                            {t("MoreInfAndRsv")}
                        </Link>
                    </div>
                </> :
                /* voucher with open price */
                <form onSubmit={handleSubmit((data) => submitForm(data, prod.productId, prod))}>
                    <h2 role="application" aria-roledescription={t("Description")} aria-label={getProductTranslations(prod).productName ? getProductTranslations(prod).productName : prod.productName} className="name" dangerouslySetInnerHTML={{ __html: getProductTranslations(prod).productName ? getProductTranslations(prod).productName : prod.productName }}></h2>
                    <div className="price-input-wrap">
                        <span className="error" id="InsertPrice-error">{errors?.["freePriceInput" + prod.productId]?.message}</span>
                        {(!prod.productMaximumPrice || (prod.productMinimumPrice < prod.productMaximumPrice)) &&
                            <div>
                                <input
                                    aria-label={`${t("InsertPrice")} ${(prod.productMinimumPrice && prod.productMaximumPrice ? (" " + t("Between") + " " + prod.productMinimumPrice + " - " + prod.productMaximumPrice) : ((prod.productMinimumPrice && !prod.productMaximumPrice ? (" " + t("From") + " " + prod.productMinimumPrice) : "")))}`}
                                    type="number"
                                    className="freePriceInput"
                                    name={"freePriceInput" + prod.productId}
                                    {...register("freePriceInput" + prod.productId, {
                                        required: t("PriceMoreThen").replace("[0]", "0"),
                                        ...(prod.productMaximumPrice && {
                                            max: {
                                                value: prod.productMaximumPrice,
                                                message: t("InsertPrice") + " " + t("Between") + " " + prod.productMinimumPrice + "-" + prod.productMaximumPrice,
                                            }
                                        }),
                                        validate: (val) => {
                                            const num = Number(val);
                                            if (num <= 0) {
                                                return t("PriceMoreThen").replace("[0]", "0");
                                            }
                                            if (prod.productMinimumPrice && num < prod.productMinimumPrice) {
                                                return t("PriceMoreThen").replace("[0]", prod.productMinimumPrice);
                                            }
                                            return true;
                                        },
                                    })}
                                    placeholder={t("InsertPrice") + (prod.productMinimumPrice && prod.productMaximumPrice ? (" " + t("Between") + " " + prod.productMinimumPrice + "-" + prod.productMaximumPrice) : ((prod.productMinimumPrice && !prod.productMaximumPrice ? (" " + t("From") + " " + prod.productMinimumPrice) : "")))}
                                    aria-describedby='InsertPrice-error'
                                />
                                <span className="crnc">{prod?.currencyCode === 'USD' ? '$' : '₪'}</span>
                            </div>
                        }
                    </div>
                    <input type="hidden" value={prod.productId} name={"prodID" + prod.productId} {...register("prodID" + prod.productId, {
                        required: false,
                    })}></input>
                    <input type="hidden" value={prod.productMinimumPrice || ""} name={"productMinimumPrice" + prod.productId} {...register("productMinimumPrice" + prod.productId)}></input>
                    <input type="hidden" value={prod.productMaximumPrice || ""} name={"productMaximumPrice" + prod.productId} {...register("productMaximumPrice" + prod.productId)}></input>
                    <button type="submit" className="btn" aria-label={`${t("Choose")} ${getProductTranslations(prod).productName}`}>
                        {`${t("Choose")}`}</button>
                </form>
            }
        </div>
    )
}

export default OpenValueProduct